import { render } from "./LoggedIn.vue?vue&type=template&id=db0c23d4"
import script from "./LoggedIn.vue?vue&type=script&lang=js"
export * from "./LoggedIn.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__